import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Location, NgClass } from '@angular/common';
import { LeftMenuBlock } from '@shared/models/left-menu-block.model';
import { CollapseDirective } from '@sb-tools/typescript/directives/collapse.directive';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { TruncatePipe } from '@sb-tools/typescript/pipes/truncate.pipe';
import { InlineSVGComponent } from '../../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'app-left-menu-block',
    templateUrl: './left-menu-block.component.html',
    styleUrls: ['./left-menu-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CollapseDirective,
        NgClass,
        RouterLinkActive,
        RouterLink,
        TranslatePipe,
        TruncatePipe,
        InlineSVGComponent,
    ],
})
export class LeftMenuBlockComponent {
    @Input() menu: LeftMenuBlock;

    constructor(public location: Location) {}
}
